import type { TourId } from './types'
import { ALL_TOUR_IDS } from './catalog'

const LEGACY_TOUR_SHOWN_KEY = 'tour-shown'
const MIGRATION_FLAG_KEY = 'tours:migrated-from-legacy'
const TOURS_V3_MIGRATION_KEY = 'tours:migrated-to-v3'

const LEGACY_PROJECT_TABS_TOUR_ID = 'tour.project-tabs'
const LEGACY_EDITOR_TOUR_ID = 'tour.editor'

export function tourSeenStorageKey(tourId: TourId): string {
  return `${tourId}:seen`
}

export function hasSeenTour(tourId: TourId): boolean {
  return localStorage.getItem(tourSeenStorageKey(tourId)) === 'true'
}

export function markTourSeen(tourId: TourId): void {
  localStorage.setItem(tourSeenStorageKey(tourId), 'true')
}

export function clearTourSeen(tourId: TourId): void {
  localStorage.removeItem(tourSeenStorageKey(tourId))
}

export function markAllToursSeen(): void {
  for (const tourId of ALL_TOUR_IDS) {
    markTourSeen(tourId)
  }
}

/** One-time bridge: users who saw the old 1/3–3/3 tour skip all new auto-tours. */
export function migrateLegacyTourFlag(): void {
  if (localStorage.getItem(MIGRATION_FLAG_KEY) === '1') {
    return
  }
  if (localStorage.getItem(LEGACY_TOUR_SHOWN_KEY) === 'true') {
    markAllToursSeen()
  }
  localStorage.setItem(MIGRATION_FLAG_KEY, '1')
}

/** Map v2 per-screen tours to v3 per-tab tours. */
export function migrateToursV3(): void {
  if (localStorage.getItem(TOURS_V3_MIGRATION_KEY) === '1') {
    return
  }

  if (localStorage.getItem(`${LEGACY_PROJECT_TABS_TOUR_ID}:seen`) === 'true') {
    markAllToursSeen()
  } else if (localStorage.getItem(`${LEGACY_EDITOR_TOUR_ID}:seen`) === 'true') {
    markTourSeen('tour.tab.editor')
  }

  localStorage.setItem(TOURS_V3_MIGRATION_KEY, '1')
}

/** Device-level tour flags that should survive logout. */
export function isPersistedTourStorageKey(key: string): boolean {
  if (
    key === LEGACY_TOUR_SHOWN_KEY ||
    key === MIGRATION_FLAG_KEY ||
    key === TOURS_V3_MIGRATION_KEY
  ) {
    return true
  }
  if (key === `${LEGACY_PROJECT_TABS_TOUR_ID}:seen` || key === `${LEGACY_EDITOR_TOUR_ID}:seen`) {
    return true
  }
  if (key === 'tour.welcome-sidebar:seen') {
    return true
  }
  return key.startsWith('tour.') && key.endsWith(':seen')
}
